import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-failed',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.scss']
})
export class FailedComponent implements OnInit {
  errorMsg: string = 'There is an issue with your account.';
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
      this.route.params
        .subscribe(
          (params: Params) => {
            if (params['reason'] == 'disabled')
              this.errorMsg = 'Your account is currently disabled.'
            if (params['reason'] == 'not-found')
              this.errorMsg = 'Your email address was not found in the Fast Track database.'
          }
        );
  }
}
